// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeByProperty<T extends { [key: string]: any }>(firstArray: T[], secondArray: T[], property: string): T[] {
  return [
    ...firstArray.filter((aa) => {
      return !secondArray.some((bb) => {
        return aa[property] === bb[property];
      });
    }),
    ...secondArray,
  ];
}
